/** True when the phone can hand files to other apps (WhatsApp and so on) through the share sheet. */
export function canShareFiles(): boolean {
  try {
    const probe = new File([new Blob(['x'], { type: 'image/png' })], 'x.png', { type: 'image/png' });
    return typeof navigator.share === 'function' && !!navigator.canShare?.({ files: [probe] });
  } catch {
    return false;
  }
}

export function download(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}

/**
 * Opens the share sheet with the file (the person picks WhatsApp). The file goes alone: with text as well,
 * some WhatsApp versions send only the text. Saves the file instead where sharing isn't possible.
 */
export async function shareFile(blob: Blob, filename: string): Promise<'shared' | 'saved' | 'cancelled'> {
  const file = new File([blob], filename, { type: blob.type });
  if (typeof navigator.share === 'function' && navigator.canShare?.({ files: [file] })) {
    try {
      await navigator.share({ files: [file] });
      return 'shared';
    } catch (e) {
      if ((e as Error).name === 'AbortError') return 'cancelled';
    }
  }
  download(blob, filename);
  return 'saved';
}

/** File names without spaces or punctuation that some phones mangle. */
export const fileName = (...parts: string[]) => parts.join('-').replace(/[^A-Za-z0-9]+/g, '-').replace(/^-|-$/g, '');
